import { useReducer } from "react";
import TrainingContext, { initialState } from "./TrainingContext";
import TrainingReducer from "./TrainingReducer";

const TrainingState = (props: any) => {
  const [state, dispatch] = useReducer(TrainingReducer, initialState);
  return (
    <TrainingContext.Provider value={{ state, dispatch }}>
      {props.children}
    </TrainingContext.Provider>
  );
};
export default TrainingState;
